import styled, { css } from "styled-components";

interface InfoTableContainerProps {
  width?: string;
}
export const InfoTableContainer = styled.div<InfoTableContainerProps>`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  width: ${({ width }) => width ?? "100%"};
  margin-top: 1rem;

  ${(props) =>
    props.id === "selected-candidates-info" &&
    css`
      padding-left: 1rem;
    `}
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin: 1rem;
  padding: 0;
`;

export const ContainerTable = styled.table`
  border-collapse: collapse;
  margin: 1rem 0;
  border-radius: 1rem !important;
  padding: 0.5rem;
  width: 1180px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 50px;

  ${(props) =>
    props.id === "selected-candidates-table" &&
    css`
      margin: 1rem;
    `}
`;

export const TableRow = styled.tr`
  font-size: 0.9rem;
  
  &:not(:first-child) {
    height: 3.5rem;
  }

  td:first-child,
  th:first-child {
    padding-left: 1rem;
  }

  &:hover {
    td {
      cursor: pointer;
      background-color: #f0f0f0;
    }
  }

  &:nth-child(odd) {
    background-color: #f8f8f8;
  }

  &:nth-child(even) {
    background-color: #ffffff;
  }

  &:first-child {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    th:first-child {
      border-top-left-radius: 0.5rem;
    }
    th:last-child {
      border-top-right-radius: 0.5rem;
    }
  }

  &:last-child {
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    td:first-child {
      border-bottom-left-radius: 0.5rem;
    }
    td:last-child {
      border-bottom-right-radius: 0.5rem;
    }
  }
`;

interface DataCellProps {
  color?: string;
  bold?: number;
}
export const DataCell = styled.td<DataCellProps>`
  padding: 0.5rem;
  color: ${({ color }) => color ?? "#6A6A6A"};
  font-weight: ${({ bold }) => bold ?? 400};
  vertical-align: middle;
  background-color: transparent;
`;
